import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function UpgradeLimitModal() {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => setInfo(e.detail);
    window.addEventListener('plan-limit-reached', handler);
    return () => window.removeEventListener('plan-limit-reached', handler);
  }, []);

  if (!info) return null;

  return (
    <div
      onClick={() => setInfo(null)}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: 'var(--bg-card, #0f1420)', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 16, padding: 32, maxWidth: 420, textAlign: 'center' }}
      >
        <div style={{ fontSize: 40, marginBottom: 12 }}>🚀</div>
        <h2 style={{ margin: '0 0 8px' }}>Plan Limit Reached</h2>
        <p style={{ color: '#8899b4', marginBottom: 24 }}>{info.message}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            onClick={() => setInfo(null)}
            style={{ padding: '10px 20px', borderRadius: 8, background: 'var(--bg-secondary, #1a2030)', border: '1px solid var(--border, #2a3040)', color: '#8899b4', fontWeight: 600, cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            onClick={() => { setInfo(null); navigate('/settings'); }}
            style={{ padding: '10px 20px', borderRadius: 8, background: '#6366f1', border: 'none', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
          >
            Upgrade Plan →
          </button>
        </div>
      </div>
    </div>
  );
}
